/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CreateUserDto = {
    phone_number: string;
    password: string;
    full_name: string;
    hometown?: string;
    birthday?: string;
    gender?: CreateUserDto.gender;
    username: string;
    address?: string;
    images?: Array<string>;
    group_id: number;
    salary: number;
    bank_name?: string;
    bank_number?: string;
};

export namespace CreateUserDto {

    export enum gender {
        '_0' = 0,
        '_1' = 1,
        '_3' = 3,
    }


}

